import type { AxiosError } from 'axios';
import type { PaginationExtendedData } from 'models';
import { type InfiniteData, type UseInfiniteQueryOptions, useInfiniteQuery } from './useInfiniteQuery';
import type { QueryKey } from '.';

export const usePaginatedInfiniteQuery = <
  TQueryFunctionData extends PaginationExtendedData<unknown>,
  TError extends AxiosError = AxiosError,
  TData = InfiniteData<TQueryFunctionData>,
  TQueryKey extends QueryKey = QueryKey,
>(
  options: Omit<
    UseInfiniteQueryOptions<TQueryFunctionData, TError, TData, TQueryKey, number>,
    'getNextPageParam' | 'initialPageParam'
  >,
) =>
  useInfiniteQuery<TQueryFunctionData, number, TError, TData, TQueryKey>({
    getNextPageParam(lastPage) {
      const lastPageSkip = lastPage.skip;
      const lastPageTotal = lastPage.total;
      const lastPageLength = lastPage.data.length;

      return lastPageSkip + lastPageLength < lastPageTotal ? lastPageSkip + lastPageLength : null;
    },
    initialPageParam: 0,
    ...options,
  });
